import { shape, string, instanceOf } from 'prop-types';

export default shape({
  _id: string.isRequired,
  name: string.isRequired,
  initials: string.isRequired,
  createdAt: instanceOf(Date).isRequired,
  updatedAt: instanceOf(Date).isRequired,
});
